export default {
  namespaced: true,
  state: {
    items: [
      {
          img: 'tools',
          text: 'Production',
          link: {name: 'production'},
          admin: true
      },
      {
        img: 'clipboard',
        text: 'View My Orders',
        link: {name: 'orderList'},
      },
      {
        img: 'edit',
        text: 'Create New Order',
        link: {name: 'customer-details'},
      },
      {
        img: 'user-cog',
        text: 'Account Settings',
        link: {name: 'settings'},
      },
        {
            img: 'dollar-sign',
            text: 'Finances',
            link: {name: 'finances'},
            admin: true
        },
        {
            img: 'handshake',
            text: 'Dealers',
            link: {name: 'dealers'},
            admin: true
        },
      {
        img: 'question-circle',
        text: 'Get Help With The System',
        link: 'https://starlinesecurity.net.au',
        target: 'blank'
      },
      {
        img: 'hand-holding-usd',
        text: 'Finance Control',
        link: {name: 'financial-control'},
        // link: {name: 'finances'},
        admin: true
      },
    ],
  },
  getters: {
    items(state) {
      return state.items;
    },
  },
  mutations: {

  },
  actions: {

  },
};
